// ESLDetails.js
import React, { useEffect, useState } from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { Container, Square } from "./styles";
import {
  MDBRow,
  MDBCol,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
} from "mdb-react-ui-kit";
import "material-symbols";
import api from "../../services/api";

const ESLDetails = () => {
  const [esl, setESL] = useState([]);
  const [logs, setLogs] = useState();
  const mac = useLocation().pathname.split("/")[2];

  useEffect(() => {
    api.get(`/esls/details/${mac}`).then((response) => {
      setESL(response.data[0]);
    });
    api.get(`/logs/action/${mac}`).then((response) => {
      setLogs(response.data);
    });
  }, [mac]);

  return (
    <Container>
      <MDBRow className="text-start">
        <h3>Detalhamento de ESL</h3>
        <MDBCol md="4" className="mt-md-0 mt-4">
          <Square>
            <h5>Identificação da ESL</h5>
            <MDBRow className="text-start">
              <MDBRow>
                <MDBCol md="6">
                  <strong>MAC:</strong>
                </MDBCol>
                <MDBCol md="6">{esl.mac}</MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>ESL Size:</strong>
                </MDBCol>
                <MDBCol md="6">
                  {esl.size === "S" ? "2.1 pol" : "2.9 pol"}
                </MDBCol>
              </MDBRow>
            </MDBRow>
          </Square>
        </MDBCol>
        <MDBCol md="4" className="mt-md-0 mt-4">
          <Square>
            <h5>Local da Instalação</h5>
            <MDBRow className="text-start">
              <MDBRow>
                <MDBCol md="6">
                  <strong>ESL Status:</strong>
                </MDBCol>
                <MDBCol md="6">
                  {esl.commission_status === "K" && (
                    <strong style={{ color: "green" }}>Comissionada</strong>
                  )}
                  {esl.commission_status !== "K" &&
                    esl.install_status === "K" && (
                      <strong style={{ color: "green" }}>Instalada</strong>
                    )}
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>Loja:</strong>
                </MDBCol>
                <MDBCol md="6">
                  {esl.business_unit_code} - {esl.location}
                </MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>SGLN:</strong>
                </MDBCol>
                <MDBCol md="6">
                  {esl.sgln &&
                    "Seção:" +
                      esl.sgln.slice(2, 4) +
                      " - Prat:" +
                      esl.sgln.slice(5, 6) +
                      " - Nível:" +
                      esl.sgln.slice(7, 8) +
                      " - Slot:" +
                      esl.sgln.slice(9, 10) +
                      " - Face:" +
                      esl.sgln.slice(11, 12)}
                </MDBCol>
              </MDBRow>
              <MDBRow className="justify-content-center align-items-center text-center">
                <MDBCol md="12" className="table-responsive">
                  <br />
                  <MDBTable>
                    <MDBTableHead>
                      <tr>
                        <th scope="col">Seção</th>
                        <th scope="col">Prat</th>
                        <th scope="col">Nível</th>
                        <th scope="col">Slot</th>
                        <th scope="col">Face</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      <tr>
                        <td>{esl.section}</td>
                        <td>{esl.shelf}</td>
                        <td>{esl.level}</td>
                        <td>{esl.slot}</td>
                        <td>{esl.face}</td>
                      </tr>
                    </MDBTableBody>
                  </MDBTable>
                </MDBCol>
              </MDBRow>
            </MDBRow>
          </Square>
        </MDBCol>
        <MDBCol md="4" className="mt-md-0 mt-4">
          <Square>
            <h5>Tag de Preço Atual</h5>
            <MDBRow className="text-start">
              <MDBRow>
                <MDBCol md="6">
                  <strong>Descrição do Produto:</strong>
                </MDBCol>
                <MDBCol md="6">{esl.product_title}</MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>Preço de Venda:</strong>
                </MDBCol>
                <MDBCol md="6">R$ {esl.product_price}</MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>Avaliação:</strong>
                </MDBCol>
                <MDBCol md="6">{esl.product_rating}</MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>GTIN:</strong>
                </MDBCol>
                <MDBCol md="6">{esl.product_gtin}</MDBCol>
              </MDBRow>
              <MDBRow>
                <MDBCol md="6">
                  <strong>Tag:</strong>
                </MDBCol>
              </MDBRow>
              <MDBRow className="justify-content-center align-items-center">
                <MDBCol md="6">
                  {esl.render ? (
                    <img
                      src={`data:image/jpeg;base64,${esl.render}`}
                      alt={esl.product_title}
                      width="100%"
                    />
                  ) : (
                    <img
                      src="https://www.thermaxglobal.com/wp-content/uploads/2020/05/image-not-found.jpg"
                      alt={esl.product_title}
                      width="100%"
                    />
                  )}
                </MDBCol>
              </MDBRow>
            </MDBRow>
          </Square>
        </MDBCol>
      </MDBRow>

      <MDBRow className="text-start" style={{ marginTop: "10px" }}>
        <h3>Histórico de Ações com a ESL</h3>
        <MDBTable align="center" className="text-center">
          <MDBTableHead>
            <tr>
              <th scope="col">Ação</th>
              <th scope="col">Data</th>
              <th scope="col">Loja</th>
              <th scope="col">Funcionário</th>
              <th scope="col">GTIN</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {logs?.actions.map((action) => (
              <tr className="table-light">
                {action.action === "commission" && <td>Comissionada</td>}
                {action.action === "uncommission" && <td>Descomissionada</td>}
                {action.action === "install" && <td>Instalada</td>}
                {action.action === "uninstall" && <td>Desinstalada</td>}
                <td>
                  {moment.utc(action.timestamp).format("HH:mm:ss - DD/MM/YYYY")}
                </td>
                <td>{action.sgln && action.sgln.slice(0, 1)}</td>
                <td>{action.employeeLeroyCode}</td>
                {action.action === "commission" && (
                  <td>{action.productGtin}</td>
                )}
              </tr>
            ))}
          </MDBTableBody>
        </MDBTable>
      </MDBRow>
    </Container>
  );
};

export default ESLDetails;
